import { useInsightsSectionContent } from './useInsightsSectionContent';
import { parseInsightsSubscribeContent } from '../utils/insightsContent';

export const useInsightsSubscribeContent = () =>
  useInsightsSectionContent(parseInsightsSubscribeContent);
